import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import useAuth from './useAuth'

const PublicRoutes = () => {
  const auth = useAuth()
  return auth ? <Navigate to="/dashboard" /> : <Outlet />
}

export default PublicRoutes
